import styled from '@emotion/styled';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';
import { list, mainColors } from '../../../assets/colors';

interface QuestionItemType {
    isHighlighted?: boolean;
}

export const QuestionItem = styled('div', { label: 'QuestionItem' })<QuestionItemType>`
    background: ${mainColors.default.light};
    border-bottom: 1px solid ${list.listItem.borderColor};
    display: flex;
    justify-content: space-between;
    padding: 16px;
    align-items: center;
    font-size: ${fontSize.xRegular};
    opacity: ${({ isHighlighted }): string => isHighlighted === true ? '1' : '0.4'};
    &:not(:last-of-type) {
        margin-bottom: 8px;
    }
    &:hover {
        opacity: 1;
    }
`;

export const QuestionText = styled('div', { label: 'QuestionText' })`
    color: ${mainColors.main.primary};
    font-weight: ${fontWeight.bold};
`;

export const ButtonWrapper = styled(ButtonsWrapper, { label: 'ButtonWrapper' })`
    min-width: 160px;
`;
